var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpeningStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 2v2h2.586L16 14.586l-4-4-9.707 9.707 1.414 1.414L12 13.414l4 4 12-12V8h2V2zM3.586 23 2 24.586V30h8v-5.414L8.414 23zM8 28H4v-2.586L4.414 25h3.172l.414.414zM13.586 19 12 20.586V30h8v-9.414L18.414 19zM18 28h-4v-6.586l.414-.414h3.172l.414.414zM23.586 13 22 14.586V30h8V14.586L28.414 13zM28 28h-4V15.414l.414-.414h3.172l.414.414z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningStock);
export default __webpack_public_path__ + "static/media/opening-stock.a5a320e95c2f851e6be9ef9d8c4a772b.svg";
export { ForwardRef as ReactComponent };